import INVENTORY_API_BASE_URL from "../../config/api";
import { apiFetch } from "../../config/apiClient";
import React, { useEffect, useState } from "react";
import { useQuery } from "@apollo/client";
import { GET_PO_DATA } from "../queries";
import { PDFDownloadLink } from "@react-pdf/renderer";
import MissingBatchPDF from "./MisPdf.js";
import "./page.css";
import Table from "react-bootstrap/Table";
import { useNavigate } from "react-router-dom";
import { CSVLink } from "react-csv";

const MIsPdf = () => {
  const { loading: gqlLoading, error: gqlError, data } = useQuery(GET_PO_DATA);
  const [batchData, setBatchData] = useState({});
  const [apiLoading, setApiLoading] = useState(true);
  const [apiError, setApiError] = useState(null);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    if (!gqlLoading && data?.getAllPOGiven) {
      const allBatchIds = [];

      data.getAllPOGiven.forEach((po) => {
        po.updatedQuantity.forEach((item) => {
          if (item.batchid) {
            allBatchIds.push(item.batchid);
          }
        });
      });

      const uniqueBatchIds = [...new Set(allBatchIds)];

      const fetchBatchData = async () => {
        try {
          const response = await apiFetch(
            `${INVENTORY_API_BASE_URL}/get-batch-challanquantity`,
            {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify({ batchIds: uniqueBatchIds }),
            }
          );

          if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
          }

          const result = await response.json();

          setBatchData(result.result);
        } catch (err) {
          setApiError(err.message);
        } finally {
          setApiLoading(false);
        }
      };
      fetchBatchData();
    }
  }, [gqlLoading, data]);

  if (gqlLoading || apiLoading)
    return (
      <div className="MIsPdf-container mis-pdf-page">
        <div className="mis-pdf-state" role="status">
          <span className="mis-pdf-spinner" aria-hidden="true" />
          Loading purchase MIS data…
        </div>
      </div>
    );
  if (gqlError)
    return (
      <div className="MIsPdf-container mis-pdf-page">
        <div className="mis-pdf-state mis-pdf-state--error" role="alert">
          Error loading GraphQL data: {gqlError.message}
        </div>
      </div>
    );
  if (apiError)
    return (
      <div className="MIsPdf-container mis-pdf-page">
        <div className="mis-pdf-state mis-pdf-state--error" role="alert">
          Error fetching challan quantity: {apiError}
        </div>
      </div>
    );

  const filteredPOData = data?.getAllPOGiven?.filter((po) => {
    if (!startDate || !endDate) return true;
    const approvalDate = new Date(po.ApprovalDate);
    const start = new Date(startDate);
    const end = new Date(endDate);
    return approvalDate >= start && approvalDate <= end;
  });

  let totalRemainingConsidered = 0;
  let totalRemainingValue = 0;
  let ActualReceivedQty = 0;
  let ActualRemainingValue = 0;
  let totalOrderedQty = 0;
  let totalOrderedValue = 0;





 filteredPOData?.forEach((po) => {
    po.updatedQuantity.forEach((item) => {
      const receivedQty = batchData[item.batchid];
      const approvedQty = item.approvedquantity;
      const remainingQty =
        typeof receivedQty === "number"
          ? approvedQty - receivedQty
          : approvedQty;

      const consideredQty =
        receivedQty !== undefined && remainingQty <= approvedQty * 0.05
          ? 0
          : remainingQty;

      const value = item.purchasePrice * consideredQty;
      const value3 = item.purchasePrice * approvedQty;

      if (receivedQty !== undefined) {
        totalRemainingConsidered += consideredQty;
        totalRemainingValue += value;
         if (remainingQty > 0) {
    ActualReceivedQty += remainingQty;
     ActualRemainingValue += item.purchasePrice * remainingQty;
  }
        totalOrderedQty += approvedQty;
        totalOrderedValue += value3;
      }
    });
  });

  const csvHeaders = [
    { label: "Title", key: "title" },
    { label: "Batch ID", key: "batchid" },
    { label: "Medium", key: "Medium" },
    { label: "Edition", key: "edition" },
    { label: "Order Date", key: "orderDate" },
    { label: "Approved Quantity", key: "approvedQty" },
    { label: "Received Quantity", key: "receivedQty" },
    { label: "Remaining Quantity", key: "remainingQty" },
    { label: "Remaining Considered", key: "remainingConsidered" },
    { label: "Purchase Price", key: "purchasePrice" },
    { label: "Remaining Value (₹)", key: "remainingValue" },
  ];

  const csvData = [];

  filteredPOData?.forEach((po) => {
    po.updatedQuantity.forEach((item) => {
      const receivedQty = batchData[item.batchid];
      const approvedQty = item.approvedquantity;
      const remainingQty =
        typeof receivedQty === "number"
          ? approvedQty - receivedQty
          : approvedQty;
      const remainingConsidered =
        receivedQty !== undefined && remainingQty <= approvedQty * 0.05
          ? 0
          : remainingQty;
      const remainingValue = item.purchasePrice * remainingConsidered;

      csvData.push({
        title: item.title,
        batchid: item.batchid,
        Medium: item.Medium,
        edition: item.edition,
        orderDate: new Date(po.ApprovalDate).toLocaleDateString("en-GB"),
        approvedQty: approvedQty,
        receivedQty: receivedQty !== undefined ? receivedQty : "",
        remainingQty: receivedQty !== undefined ? remainingQty : "",
        remainingConsidered:
          receivedQty !== undefined ? remainingConsidered : "",
        purchasePrice: item.purchasePrice,
        remainingValue:
          receivedQty !== undefined ? remainingValue.toFixed(2) : "",
      });
    });
  });

  const pdfItems = [];

  filteredPOData?.forEach((po) => {
    po.updatedQuantity.forEach((item) => {
      const receivedQty = batchData[item.batchid];
      const approvedQty = item.approvedquantity;
      const differenceQty =
        typeof receivedQty === "number"
          ? approvedQty - receivedQty
          : approvedQty;

      if (
        receivedQty === "Pending" ||
        (typeof receivedQty === "number" && differenceQty > 20)
      ) {
        pdfItems.push({
          orderid: po.orderid,
          ApprovalDate: po.ApprovalDate,
          title: item.title,
          batchid: item.batchid,
          Oquantity: approvedQty,
          quantity: differenceQty,
          receivedQty: receivedQty !== undefined ? receivedQty : "",
        });
      }
    });
  });

  return (
    <div className="MIsPdf-container mis-pdf-page">
      <main className="mis-pdf-content">
        <header className="mis-pdf-hero">
          <div>
            <span className="mis-pdf-eyebrow">REPORTS / PURCHASING</span>
            <h1>Purchase MIS Report</h1>
            <p>Review approved quantities, receipts, remaining stock, and order value.</p>
          </div>
          <div className="mis-pdf-hero-badge">
            <span className="mis-pdf-hero-badge-mark" aria-hidden="true">PO</span>
            <span>
              <strong>{filteredPOData?.length ?? 0} orders</strong>
              <small>in the current view</small>
            </span>
          </div>
        </header>

        <section className="mis-pdf-metrics" aria-label="Purchase report totals">
          <article className="mis-pdf-metric-card mis-pdf-metric-card--blue">
            <span>Total remaining considered</span>
            <strong>{totalRemainingConsidered}</strong>
            <small>Adjusted for received quantity</small>
          </article>
          <article className="mis-pdf-metric-card mis-pdf-metric-card--green">
            <span>Remaining considered value</span>
            <strong>₹{totalRemainingValue.toFixed(2)}</strong>
            <small>Current report total</small>
          </article>
          <article className="mis-pdf-metric-card mis-pdf-metric-card--orange">
            <span>Actual remaining quantity</span>
            <strong>{ActualReceivedQty}</strong>
            <small>Quantity still outstanding</small>
          </article>
          <article className="mis-pdf-metric-card mis-pdf-metric-card--violet">
            <span>Actual remaining value</span>
            <strong>₹{ActualRemainingValue.toFixed(2)}</strong>
            <small>Outstanding purchase value</small>
          </article>
          <article className="mis-pdf-metric-card">
            <span>Total approved quantity</span>
            <strong>{totalOrderedQty}</strong>
            <small>Across approved orders</small>
          </article>
          <article className="mis-pdf-metric-card">
            <span>Total approved value</span>
            <strong>₹{totalOrderedValue.toFixed(2)}</strong>
            <small>Approved purchase value</small>
          </article>
        </section>

        <section className="mis-pdf-filter-card" aria-labelledby="mis-pdf-filter-title">
          <div className="mis-pdf-section-heading">
            <div>
              <span className="mis-pdf-section-kicker">NARROW THE RESULTS</span>
              <h2 id="mis-pdf-filter-title">Filter by approval date</h2>
            </div>
            <button
              type="button"
              className="mis-pdf-clear-button"
              onClick={() => {
                setStartDate("");
                setEndDate("");
              }}
            >
              Clear dates
            </button>
          </div>

          <div className="mis-pdf-filter-controls">
            <label>
              <span>Start date</span>
              <input
                type="date"
                value={startDate}
                onChange={(e) => setStartDate(e.target.value)}
              />
            </label>
            <label>
              <span>End date</span>
              <input
                type="date"
                value={endDate}
                onChange={(e) => setEndDate(e.target.value)}
              />
            </label>
          </div>
        </section>

        <div className="mis-pdf-toolbar" aria-label="Report actions">
          <button
            type="button"
            className="mis-pdf-action mis-pdf-action--back"
            onClick={() => navigate("/Viewdata")}
          >
            <span aria-hidden="true">←</span>
            Back to reports
          </button>
          <CSVLink
            data={csvData}
            headers={csvHeaders}
            filename={"MIS_Report.csv"}
            className="mis-pdf-action mis-pdf-action--csv"
          >
            Export CSV
          </CSVLink>
          {pdfItems.length > 0 && (
            <PDFDownloadLink
              document={<MissingBatchPDF pdfItems={pdfItems} />}
              fileName="Remaining_SKU_Report.pdf"
              className="mis-pdf-action mis-pdf-action--pdf"
            >
              {({ loading }) => (loading ? "Preparing PDF…" : "Generate PDF")}
            </PDFDownloadLink>
          )}
        </div>

        <section className="mis-pdf-orders" aria-labelledby="mis-pdf-orders-title">
          <div className="mis-pdf-orders-heading">
            <div>
              <span className="mis-pdf-section-kicker">PURCHASE ORDERS</span>
              <h2 id="mis-pdf-orders-title">Order details</h2>
              <p>Batch-level approved, received, and remaining quantities.</p>
            </div>
            <span className="mis-pdf-order-count">
              {filteredPOData?.length ?? 0} orders
            </span>
          </div>

          {filteredPOData?.length ? (
            filteredPOData.map((po, idx) => (
              <article className="mis-pdf-order-card" key={idx}>
                <div className="mis-pdf-order-card-heading">
                  <div>
                    <span>ORDER ID</span>
                    <h3>{po.orderid}</h3>
                  </div>
                  <div className="mis-pdf-order-date">
                    <span>Approved</span>
                    <strong>{new Date(po.ApprovalDate).toLocaleDateString("en-GB")}</strong>
                  </div>
                </div>

                {po.updatedQuantity.length > 0 ? (
                  <div className="mis-pdf-table-scroll">
                    <Table striped bordered hover className="mis-pdf-table">
                      <thead>
                        <tr>
                          {[
                            "Title",
                            "Batch ID",
                            "Medium",
                            "Edition",
                            "Order Date",
                            "Approved Quantity",
                            "Received Qty",
                            "Remaining Qty",
                            "Remaining Considered",
                            "Purchase Price",
                            "Remaining Value (₹)",
                            "Approved Value (₹)",
                          ].map((header) => (
                            <th key={header}>{header}</th>
                          ))}
                        </tr>
                      </thead>
                      <tbody>
                        {po.updatedQuantity.map((item, i) => {
                          const receivedQty = batchData[item.batchid];
                          const approvedQty = item.approvedquantity;
                          const remainingQty =
                            typeof receivedQty === "number"
                              ? approvedQty - receivedQty
                              : approvedQty;

                          return (
                            <tr key={i}>
                              <td>{item.title}</td>
                              <td>{item.batchid}</td>
                              <td>{item.Medium}</td>
                              <td>{item.edition}</td>
                              <td>{new Date(po.ApprovalDate).toLocaleDateString("en-GB")}</td>
                              <td>{approvedQty}</td>
                              <td>{receivedQty !== undefined ? receivedQty : ""}</td>
                              <td>{receivedQty !== undefined ? remainingQty : ""}</td>
                              <td>
                                {receivedQty !== undefined
                                  ? remainingQty <= approvedQty * 0.05
                                    ? 0
                                    : remainingQty
                                  : ""}
                              </td>
                              <td>{item.purchasePrice}</td>
                              <td>
                                {receivedQty !== undefined
                                  ? (
                                      item.purchasePrice *
                                      (remainingQty <= approvedQty * 0.05
                                        ? 0
                                        : remainingQty)
                                    ).toFixed(2)
                                  : ""}
                              </td>
                              <td>{(item.purchasePrice * approvedQty).toFixed(2)}</td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </Table>
                  </div>
                ) : (
                  <div className="mis-pdf-empty-row">No updated quantity data.</div>
                )}
              </article>
            ))
          ) : (
            <div className="mis-pdf-empty-state">
              No purchase orders match the selected date range.
            </div>
          )}
        </section>
      </main>
    </div>
  );
};
export default MIsPdf;
